"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Global Class  */
window.FAB_METABOX_TRIGGER = Object.assign(Object.assign({}, window.FAB_METABOX_TRIGGER), { 
    /**
     * Define Default Option
     * */
    defaultOptions: Object.assign(Object.assign({}, window.FAB_METABOX_TRIGGER.defaultOptions), { select2: { placeholder: '--choose--' } }), 
    /** Init */
    init: () => {
        /** Initiate Select2 */
        jQuery('.fab-container.metabox-triggers .select2').select2();
        window.FAB_METABOX_TRIGGER.initTypeOptions();
    }, 
    /**
     * Init select2 type
     * */
    initTypeOptions: () => {
        let options = [];
        options = options.concat(window.FAB_METABOX_TRIGGER.defaultOptions.types);
        jQuery('.field_option_trigger_type_option').each(function () {
            let dom = jQuery(this);
            dom.select2('destroy');
            /** Init jQuery Select2 */
            dom.select2({ placeholder: '--choose--', data: options });
            if (dom.data('selected')) {
                dom.val(dom.data('selected'));
                dom.trigger('change');
            }
        });
    } });
